import React from "react";
import BasePopup from "../Popup/index";
import bgPopupCongratu from "../../../../../assets/images/Mini-Game/bg-popup-congratu1.png";
import styled from "styled-components";
import bgButton from "../../../../../assets/images/Mini-Game/bg-button-change.png";
import { useDispatch, useSelector } from "react-redux";
import { setOpenPopupIntroGift } from "../../../../../Redux/futures/mini-game/action";
import { curStateMiniGame } from "../../../../../Redux/selector";
import iconClosePopup from "../../../../../assets/images/Mini-Game/icon-close-popup.svg";
import { useNavigate } from "react-router";
import PATH from "../../../../../config/PATH";
import {
  ID_HIDDEN_POPUP_INTRO_GIFT,
  ID_TAB_MINI_GAME,
} from "../../../../../helper/const";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { getItemCookie, setCookieExpireEndOfDay } from "../../../../../utils/cookie";
import moment from "moment";
import { handleGetDataTakePrizeMinigame } from "../../../../../helper/helper";

export default function PopupIntroGift({ isShow = true, className, dataAward, setDataAward }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { dataAwardListMini, popupIntroGift } = useSelector(curStateMiniGame);

  const onCancel = () => {
    if(typeof(setDataAward) === "function"){
       setDataAward(false)
    }
    if (popupIntroGift?.isSetCookie) {
      let listId = [];
      if(getItemCookie(ID_HIDDEN_POPUP_INTRO_GIFT)) {
        listId = getItemCookie(ID_HIDDEN_POPUP_INTRO_GIFT)
      }
      const now = moment(); // thời gian hiện tại
      const formatted = now.format('YYYY-MM-DDTHH:mm:ss');
      const data = {
        timeShowPopup: formatted,
        idTakePrize: dataTakePrize.id
      }
      listId = [...listId, data]
      
      setCookieExpireEndOfDay(ID_HIDDEN_POPUP_INTRO_GIFT, JSON.stringify(listId));
    }
    
    dispatch(
      setOpenPopupIntroGift({
        isShow: false,
        isSetCookie: false,
      })
    );
  };

  let dataTakePrize = handleGetDataTakePrizeMinigame(dataAwardListMini);
  if(dataAward){
    dataTakePrize = {
      ...dataAward,
      image: dataAward?.obj_puzzle_piece?.award_image,
      id: dataAward?.obj_puzzle_piece?.id

    }
  }

  if (_.isEmpty(dataTakePrize)) {
    return null;
  }

  return (
    <BasePopup
      BasePopup
      open={true}
      className={className}
      onCancel={onCancel}
      getContainer
    >
      <Container className="popup-cong-mini">
        <img
          src={iconClosePopup}
          alt=""
          className="rule-mini-close congratula-btn-close scale-hover-item"
          onClick={onCancel}
        />
        <img src={bgPopupCongratu} alt="" className="bg-popup" />
        <div className="popup-cong-mini-main">
          <div className="container-popup-cong-mini-main">
            <div className="content-main">
              {t("mini_game.pop_up_congrats_take_prize.completed")}
            </div>
            <div className="img-prize">
              <img src={dataTakePrize?.image} alt="" />
            </div>
            <div className="content-coins">{dataTakePrize?.name}</div>
            <div
              className="button-action-cong scale-hover-item"
              onClick={() => {
                onCancel();
                navigate(
                  `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.takePrize}/${dataTakePrize?.id}`
                );
              }}
            >
              <img src={bgButton} alt="" />
              <div className="button-action-cong-content">
                {t("mini_game.homepage.piece_collection")}
              </div>
            </div>

            <div className="content-footer">
              {t(
                "mini_game.pop_up_congrats_take_prize.Prize quantities are limited."
              )}
            </div>
          </div>
        </div>
      </Container>
    </BasePopup>
  );
}

const Container = styled.div`
  position: relative;
  top: -200px;
  left: -10px;

  .congratula-btn-close {
    position: absolute;
    right: 10px;
    top: 140px;
    z-index: 3;
  }

  .content-main,
  .content-coins,
  .content-footer {
    color: #64310b;
    font-size: 16px;
    text-align: center;
    font-weight: 500;
  }

  .popup-cong-mini-main {
    position: relative;
    z-index: 2;
    top: 260px;
    width: 74%;
    left: 50%;
    transform: translateX(-50%);
  }

  .container-popup-cong-mini-main {
    left: -1.5%;
    position: relative;
    padding-top: 75px;
  }

  .img-prize {
    text-align: center;
    margin: 10px 0;

    img {
      height: 150px;
      width: auto;
    }
  }

  .bg-popup {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
    height: calc(100% + 315px);
  }

  .button-action-cong {
    position: relative;
    margin-bottom: 10px;
    text-align: center;

    .button-action-cong-content {
      position: absolute;
      top: calc(50% - 4px);
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-size: 16px;
      font-weight: 500;
      width: 100%;
    }
    img {
      width: 300px;
      height: 50px;
    }
  }

  .content-footer {
    font-style: italic;
    font-weight: 400;
    font-size: 14px;
  }

  .content-coins {
    font-size: 38px;
    font-weight: 400;
    margin: 10px 0;
    font-family: "Ganache", sans-serif;
    font-style: italic;
    color: rgba(149, 73, 17, 1);
    text-shadow: -3px -3px 0 #fff, 3px -3px 0 #fff, -3px 3px 0 #fff,
      3px 3px 0 #fff;
    line-height: 40px;
  }

  @media (max-width: 768px) {
    left: 3px;
    .content-main {
      font-size: 14px;
    }

    .content-coins {
      font-size: 28px;
      line-height: 34px;
    }

    .button-action-cong .button-action-cong-content {
      font-size: 14px;
    }

    .button-action-cong img {
      width: 80%;
      min-height: 40px;
      height: auto;
    }

    .content-footer {
      font-size: 12px;
    }
  }

  @media (max-width: 576px) {
    .content-coins {
      font-size: 22px;
      line-height: 26px;
    }

    .button-action-cong-content {
      font-size: 14px;
    }

    .button-action-cong img {
      width: 90%;
      min-height: 40px;
      height: auto;
    }

    .content-main {
      font-size: 13px;
    }

    .content-footer {
      font-size: 11px;
    }

    .button-action-cong {
      margin-bottom: 6px;
    }

    .content-coins {
      margin: 6px 0;
      margin-top: 0;
    }

    .img-prize {
      margin: 6px 0;
    }
  }

  @media (max-width: 470px) {
    .container-popup-cong-mini-main {
      padding-top: 30px;
    }

    .popup-cong-mini-main {
      width: 73%;
    }
  }
`;
